import React from 'react'

const Portfolio = () => {
  return (
    <h1 className="heading" style={{ marginLeft: '10px', padding: '10px' }}>
      Portfolio Page
    </h1>
  )
}

export default Portfolio
